import { Dexie, EntityTable } from 'dexie';

export interface ExpirationModel {
    version: string;
    timestamp: number;
}

const INDEXED_DB_NAME = 'REACH-worker-cache-expiration';
const database = new Dexie(INDEXED_DB_NAME) as Dexie & {
    serviceWorkerVersions: EntityTable<ExpirationModel, 'version'>;
};
database.version(1).stores({ serviceWorkerVersions: 'version, timestamp' });

export async function getExpiredVersions(offset: number): Promise<ExpirationModel[]> {
    return await database.serviceWorkerVersions
        .orderBy('timestamp')
        .reverse()
        .offset(offset)
        .toArray();
}

export async function updateVersion(version: string): Promise<void> {
    await database.serviceWorkerVersions.upsert(version, { version, timestamp: Date.now() });
}
